/* ----------------------------------- */
// Domain import pattern. Please       //
// follow below usage for all reducers //
/* ----------------------------------- */

import * as Infrastructure_Provider_Types from "../../actions/types/provider";
import { createReducer } from "redux-immutablejs";
import { fromJS } from "immutable";

const initial = fromJS({
  UIDisplayLanguage: "tr",
  defaultTablePageSize: 16,
  isLoading: {},
});

const provider = createReducer(initial, {
  [Infrastructure_Provider_Types.ACTIVATE_LOADING_STATUS]: (state, action) =>
    state.merge({
      isLoading: state.get("isLoading").merge({
        [action.payload]: true,
      }),
    }),
  [Infrastructure_Provider_Types.DEACTIVATE_LOADING_STATUS]: (state, action) =>
    state.merge({
      isLoading: state.get("isLoading").delete(action.payload),
    }),
  [Infrastructure_Provider_Types.CHANGE_UI_DISPLAY_LANGUAGE]: (state, action) => 
  state.merge({
      UIDisplayLanguage: action.payload,
      display: {
          language: action.payload,
          locale: `${action.payload}-${action.payload.replace('en', 'us').toUpperCase()}`
      }
  }),
});

export default provider;
